module.exports = __webpack_public_path__ + "static/adebayo-1a65cb6e0a6f2e51ac4adfa66da1b334.jpg";